import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const GA4_ID = "G-76YY01XS9F";
const CLARITY_ID = "xtrtnm4mic";

/**
 * Analytics wrapper — GA4 and Clarity are hard-installed in <head> via
 * index.html. This component only reports SPA route changes to both.
 */
export default function Analytics() {
    const location = useLocation();
    useEffect(() => {
        const path = location.pathname + location.search;
        if (typeof window.gtag === "function") {
            window.gtag("event", "page_view", {
                page_path: path,
                page_location: window.location.href,
                page_title: document.title,
                send_to: GA4_ID,
            });
        }
        if (typeof window.clarity === "function") {
            window.clarity("set", "page", path);
        }
    }, [location]);
    return null;
}
